/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icons/fast-way-5-white': {
    width: 44,
    height: 44,
    viewBox: '0 0 44 44',
    data: `
      <circle cx="36" cy="6" r="4.5" stroke="white" stroke-width="3"/>
      <path d="M19 42L24.7721 35.9242C26.8269 33.7611 26.7279 30.3386 24.5513 28.2981L23.7458 27.5429C21.9704 25.8785 21.9252 23.0748 23.646 21.354L27 18C28.4761 16.5239 31 17.5693 31 19.6569V19.6569C31 20.9509 32.0491 22 33.3431 22H42" stroke="white" stroke-width="3" stroke-linecap="round"/>
      <path d="M25.6 12.7L26.8 13.6L28.6 11.2L27.4 10.3L25.6 12.7ZM13.9393 14.9393C13.3536 15.5251 13.3536 16.4749 13.9393 17.0607C14.5251 17.6464 15.4749 17.6464 16.0607 17.0607L13.9393 14.9393ZM17.9038 10.9749L13.9393 14.9393L16.0607 17.0607L20.0251 13.0962L17.9038 10.9749ZM27.4 10.3C24.5076 8.13073 20.4603 8.41836 17.9038 10.9749L20.0251 13.0962C21.526 11.5954 23.902 11.4265 25.6 12.7L27.4 10.3Z" fill="white"/>
      <path d="M2.43934 40.9393C1.85355 41.5251 1.85355 42.4749 2.43934 43.0607C3.02513 43.6464 3.97487 43.6464 4.56066 43.0607L2.43934 40.9393ZM17.5607 30.0607L18.6213 29L16.5 26.8787L15.4393 27.9393L17.5607 30.0607ZM4.56066 43.0607L17.5607 30.0607L15.4393 27.9393L2.43934 40.9393L4.56066 43.0607Z" fill="white"/>
      <path d="M4 9H11" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
      <path d="M2 14H9" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
      <path d="M4 20H11" stroke="white" stroke-width="2.5" stroke-linecap="round"/>
    `
  }
})
